<div class="overlay" [class.visible]="isVisible" (click)="onBack()"></div>
<div class="sidebar-wrapper" *ngIf="isVisible">
   <div class="header">
            <i (click)="onBack()">arrow_back</i>
            <span >Return Item</span>
          </div>

  <!-- Request Exchange -->
  <label class="checkbox-wrapper" style="margin-top: 41px;font-weight: bold;margin-bottom: 7px;">
    <input type="checkbox" [(ngModel)]="requestExchange" />
    Request Exchange
  </label>

  <!-- Product Card -->
  <div class="product-card">
    <span *ngIf="product.discount > 0" class="discount-badge">
                {{ ((product.discount / product.price) * 100) | number:'1.0-0' }}% Off
              </span>
    <img *ngIf="product.imageUrl"  [src]="product.imageUrl" onerror="this.src='../../../../assets/images/logos/logo.png'">
      <img *ngIf="!product.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo">
    <div class="info">
      <div class="title">{{ product.partName }}</div>
      <div class="subtitle">{{ product.partNumber }}</div>
      <div class="subtitle">{{ product.brandName }}</div>
      <div class="cart-amount">
      <div class="price">
        ₹{{ product.price*selectedQty |  number: '1.2-2'}}
        <span class="original">₹{{ (product.price+product.discount)*selectedQty |  number: '1.2-2'}}</span>
        <div class="discount">You save ₹{{ product.discount*selectedQty |  number: '1.2-2'}}</div>
      </div>
      <div class="qty">
        <button (click)="decrementQty()">-</button>
        <p>{{ selectedQty }}</p>
        <button (click)="incrementQty()">+</button>
      </div>
      </div>
    </div>
  </div>

  <!-- Return Eligibility -->
  <div class="return-eligibility">
    <img src="/../../../assets/images/order-details/return.png"> Eligible for Return till {{ date | date: 'MMMM d' }}
  </div>

  <!-- Reason Section -->
  <div class="reason-section">
    <h4>Why are you returning?</h4>
    <p>Please choose the right reason as to why you're returning this item. This information is only used to improve our service.</p>
    <div class="label">Select Reason<span class="required">*</span></div>

    <div class="radio-group">
      <label *ngFor="let reason of reasons" class="radio-wrapper">
        <input
          type="radio"
          name="returnReason"
          [value]="reason"
          [(ngModel)]="selectedReason"
        />
        {{ reason }}
      </label>
    </div>
     <div *ngIf="selectedReason" class="comment-box">
    <textarea [(ngModel)]="additionalComment" placeholder="Additional Comments"></textarea>
  </div>
  </div>
<div *ngIf="!selectedReason && showErrors" class="error-msg-description" #reasonSection>
  Please Select to Proceed
</div>
<input type="file" #fileInput (change)="onImagesSelected($event)" multiple accept="image/*" hidden />

 <button class="add-image-btn" (click)="fileInput.click()">
    <i>camera_alt</i> Add Images
  </button>
  <!-- Display Images -->
<div class="uploaded-images" *ngIf="selectedImages.length > 0">
  <div class="image-box" *ngFor="let img of selectedImages; let i = index">
    <img [src]="img.preview" alt="uploaded image" />
    <button class="remove-btn" (click)="removeImage(i)">×</button>
  </div>
</div>

<div *ngIf="!imageUploaded && showErrors" class="error-msg-description" #imageSection>
  To avoid any delays or rejection of your return request, kindly upload clear and original images of the product delivered.
</div>
  <!-- Confirmation -->
   <div  style="margin-bottom: 55px;">
  <label class="checkbox-wrapper" style="margin: 5px 0;">
    <div style=" margin-top: -13px;">
    <input type="checkbox" [(ngModel)]="productUnused" />
    </div>
    I confirm that the product is unused with the original tags intact
  </label>
  <div *ngIf="!productUnused && showErrors" class="error-msg-description" #checkboxSection>
  Please Confirm to Proceed
</div>
</div>
  <!-- Footer -->
  <div class="footer-bar">
    <div class="price">  <span class="qtyShow">{{ selectedQty }}</span>₹{{ product.price*selectedQty |  number: '1.2-2'}}</div>
    <button [ngClass]="{ 'btn-disabled': !canProceed, 'pickup-btn': canProceed }" (click)="onProceed()">Pickup Details</button>
  </div>
</div>
<div class="overlay" [class.visible]="viewPage" (click)="onBackPage()"></div>
<div class="sidebar-wrapper" *ngIf="viewPage">
   <div class="header">
            <i (click)="onBackPage()">arrow_back</i>
            <span >Return Item</span>
          </div>

  <!-- Request Exchange -->
  <label class="checkbox-wrapper" style="margin-top: 35px;font-weight: bold;margin-bottom: 7px;" *ngIf="requestExchange">
     You are replacing
  </label>
<label class="checkbox-wrapper" style="margin-top: 35px;font-weight: bold;margin-bottom: 7px;" *ngIf="!requestExchange">
     You are returning
  </label>
  <!-- Product Card -->
  <div class="product-card">
    <span *ngIf="product.discount > 0" class="discount-badge">
                {{ ((product.discount / product.price) * 100) | number:'1.0-0' }}% Off
              </span>
    <img *ngIf="product.imageUrl"  [src]="product.imageUrl" onerror="this.src='../../../../assets/images/logos/logo.png'">
      <img *ngIf="!product.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo">
    <div class="info">
      <div class="title">{{ product.partName }}</div>
      <div class="subtitle">{{ product.partNumber }}</div>
      <div class="subtitle">{{ product.brandName }}</div>
      <div class="cart-amount">
      <div class="price">
        ₹{{ product.price*selectedQty |  number: '1.2-2'}}
        <span class="original">₹{{ (product.price+product.discount)*selectedQty |  number: '1.2-2'}}</span>
        <div class="discount">You save ₹{{ product.discount*selectedQty |  number: '1.2-2'}}</div>
      </div>
      <div class="qty">
        <button (click)="decrementQty()">-</button>
        <p>{{ selectedQty }}</p>
        <button (click)="incrementQty()">+</button>
      </div>
      </div>
    </div>
  </div>

  <!-- Return Eligibility -->
  <div class="return-eligibility">
    <img src="/../../../assets/images/order-details/return.png"> The item will be pickup by {{day}}
  </div>

  <!-- Reason Section -->
  <div class="reason-section" style="margin-bottom: 0;">
    <h4>Picked Up Address</h4>
    <h2>{{contactName}}</h2>
    <p style="margin-top: 0px;">{{addresses?.address}}, {{addresses?.locality}}, {{addresses?.city}}, {{addresses?.state}}, {{addresses?.country}}, {{addresses?.pincode}}</p>
   
  </div>
<div class="credit-note">
  <h4>Autoverse Credit Note</h4>
  <p>Credit note of <strong>₹{{ product.price*selectedQty |  number: '1.2-2'}} </strong> will be initiated after the item is picked up and quality check has passed </p>
</div>
  <!-- Display Images -->
<div class="uploaded-images" *ngIf="selectedImages.length > 0" style="margin-bottom: 54px;">
  <div class="image-box" *ngFor="let img of selectedImages; let i = index">
    <img [src]="img.preview" alt="uploaded image" />
    <!-- <button class="remove-btn" (click)="removeImage(i)">×</button> -->
  </div>
</div>

  <!-- Footer -->
  <div class="footer-bar">
    <div class="price">  <span class="qtyShow">{{ selectedQty }}</span>₹{{ product.price*selectedQty|  number: '1.2-2'}}</div>
    <button class="pickup-btn" (click)="submitReturn()">Confirm</button>
  </div>
</div>
<div class="overlay" [class.visible]="openSuccess" (click)="loadorderdetails()"></div>
<div class="sidebar-wrapper" *ngIf="openSuccess">
   <div class="header">
            <i (click)="loadorderdetails()">arrow_back</i>
            <span >Return Item</span>
          </div>
          <div style="background: #f4f4f4;">
          <div class="success">
            <ng-lottie
              class="animation"
              [options]="options"
              (animationCreated)="animationCreated($event)">
            </ng-lottie>
            <h3>Return Request Submited</h3>
            <p>Return ID  <strong>{{created?.salesReturnNumber}}</strong> </p>
          </div>

  <!-- Product Card -->
  <div class="product-card">
    
    <img *ngIf="product.imageUrl"  [src]="product.imageUrl" onerror="this.src='../../../../assets/images/logos/logo.png'">
      <img *ngIf="!product.imageUrl" src="../../../../assets/images/logos/logo.png" alt="logo">
<div class="credit-note" style="border: none;">
  <h4>Autoverse Credit Note</h4>
  <p>Credit note of <strong>₹{{ product.price*selectedQty |  number: '1.2-2'}} </strong> will be initiated after the item is picked up and quality check has passed </p>
</div>
  </div>

  <!-- Return Eligibility -->
   <div style="background: white;padding: 1px 0;">
  <div class="picked-up">
     <div class="status-icon">
      <span class="check-circle">✓</span>
    </div> 
    <div class="by">
      <p>Picked up by</p>
      <div class="day">The item will be pickup by {{displayDate(created?.pickupDate)}}</div>
    </div>
  </div>
    <div class="picked-up">
    <img src="../../../../assets/images/order-details/warning-2.png"> 
    <div class="by">
      <p>Please Note</p>
      <div class="day" style="margin-bottom: 10px;">Keep your brand tags and product intact to give it back to the delivery agent</div>
    </div>
  </div>
  </div>

  <!-- Reason Section -->
  <div class="reason-section1" >
    <h4>Next Step</h4>
    <p style="margin-top: 0px;padding: 0px 0 10px;">Please check your Orders Page to track your return</p>
   
  </div>

<div class="return-status-wrapper">
  <div class="status-header">
    <div class="status-icon">
      <span class="check-circle">✓</span>
    </div>
    <div class="status-text">Return Request Submitted</div>
  </div>

  <div class="status-step">
    <div class="timeline">
      <div class="circle">1</div>
      <div class="line green"></div>
    </div>
    <div class="step-content">
      <div class="step-text">
        Our delivery partner will come and pickup the item from the pickup address
      </div>
    </div>
    <div class="step-icon">
      <img src="../../../../assets/images/order-details/box-tick.png" alt="box" />
    </div>
  </div>

  <div class="status-step">
    <div class="timeline">
      <div class="circle">2</div>
      <div class="line gray"></div>
    </div>
    <div class="step-content">
      <div class="step-text">
        Credit note will be created once we receive the item and it passes quality check
      </div>
    </div>
    <div class="step-icon">
      <img src="../../../../assets/images/order-details/empty-wallet-change.png" alt="wallet" />
    </div>
  </div>
</div>




  <!-- Footer -->
  <div class="footer-bar" style="justify-content: center;cursor: pointer;" (click)="loadorderdetails()">
       <button class="pickup-btn1"  >Done</button>
  </div>
</div>
</div>
<div #dynamicContainer></div>